import { ReactComponent as AcFlagIcon } from "./flags/svgs/ac Ascension Island.svg";
import { ReactComponent as AdFlagIcon } from "./flags/svgs/ad Andorra.svg";
import { ReactComponent as AeFlagIcon } from "./flags/svgs/ae United Arab Emirates.svg";
import { ReactComponent as AfFlagIcon } from "./flags/svgs/af Afghanistan.svg";
import { ReactComponent as AgFlagIcon } from "./flags/svgs/ag Antigua and Barbuda.svg";
import { ReactComponent as AiFlagIcon } from "./flags/svgs/ai Anguilla.svg";
import { ReactComponent as AlFlagIcon } from "./flags/svgs/al Albania.svg";
import { ReactComponent as AmFlagIcon } from "./flags/svgs/am Armenia.svg";
import { ReactComponent as AoFlagIcon } from "./flags/svgs/ao Angola.svg";
import { ReactComponent as AqFlagIcon } from "./flags/svgs/aq Antarctica.svg";
import { ReactComponent as ArFlagIcon } from "./flags/svgs/ar Argentina.svg";
import { ReactComponent as AsFlagIcon } from "./flags/svgs/as American Samoa.svg";
import { ReactComponent as AtFlagIcon } from "./flags/svgs/at Austria.svg";
import { ReactComponent as AuFlagIcon } from "./flags/svgs/au Australia.svg";
import { ReactComponent as AwFlagIcon } from "./flags/svgs/aw Aruba.svg";
import { ReactComponent as AxFlagIcon } from "./flags/svgs/ax Aland Islands.svg";
import { ReactComponent as AzFlagIcon } from "./flags/svgs/az Azerbaijan.svg";
import { ReactComponent as BaFlagIcon } from "./flags/svgs/ba Bosnia and Herzegovina.svg";
import { ReactComponent as BbFlagIcon } from "./flags/svgs/bb Barbados.svg";
import { ReactComponent as BdFlagIcon } from "./flags/svgs/bd Bangladesh.svg";
import { ReactComponent as BeFlagIcon } from "./flags/svgs/be Belgium.svg";
import { ReactComponent as BfFlagIcon } from "./flags/svgs/bf Burkina Faso.svg";
import { ReactComponent as BgFlagIcon } from "./flags/svgs/bg Bulgaria.svg";
import { ReactComponent as BhFlagIcon } from "./flags/svgs/bh Bahrain.svg";
import { ReactComponent as BiFlagIcon } from "./flags/svgs/bi Burundi.svg";
import { ReactComponent as BjFlagIcon } from "./flags/svgs/bj Benin.svg";
import { ReactComponent as BlFlagIcon } from "./flags/svgs/bl Saint Barthelemy.svg";
import { ReactComponent as BmFlagIcon } from "./flags/svgs/bm Bermuda.svg";
import { ReactComponent as BnFlagIcon } from "./flags/svgs/bn Brunei Darussalam.svg";
import { ReactComponent as BoFlagIcon } from "./flags/svgs/bo Bolivia.svg";
import { ReactComponent as BqFlagIcon } from "./flags/svgs/bq Bonaire, Sint Eustatius and Saba.svg";
import { ReactComponent as BrFlagIcon } from "./flags/svgs/br Brazil.svg";
import { ReactComponent as BsFlagIcon } from "./flags/svgs/bs Bahamas.svg";
import { ReactComponent as BtFlagIcon } from "./flags/svgs/bt Bhutan.svg";
import { ReactComponent as BvFlagIcon } from "./flags/svgs/bv Bouvet Island.svg";
import { ReactComponent as BwFlagIcon } from "./flags/svgs/bw Botswana.svg";
import { ReactComponent as ByFlagIcon } from "./flags/svgs/by Belarus.svg";
import { ReactComponent as BzFlagIcon } from "./flags/svgs/bz Belize.svg";
import { ReactComponent as CaFlagIcon } from "./flags/svgs/ca Canada.svg";
import { ReactComponent as CcFlagIcon } from "./flags/svgs/cc Cocos (Keeling) Islands.svg";
import { ReactComponent as CdFlagIcon } from "./flags/svgs/cd Democratic Republic of the Congo.svg";
import { ReactComponent as CeftaFlagIcon } from "./flags/svgs/cefta Central European Free Trade Agreement.svg";
import { ReactComponent as CfFlagIcon } from "./flags/svgs/cf Central African Republic.svg";
import { ReactComponent as CgFlagIcon } from "./flags/svgs/cg Republic of the Congo.svg";
import { ReactComponent as ChFlagIcon } from "./flags/svgs/ch Switzerland.svg";
import { ReactComponent as CiFlagIcon } from "./flags/svgs/ci Cote d'Ivoire.svg";
import { ReactComponent as CkFlagIcon } from "./flags/svgs/ck Cook Islands.svg";
import { ReactComponent as ClFlagIcon } from "./flags/svgs/cl Chile.svg";
import { ReactComponent as CmFlagIcon } from "./flags/svgs/cm Cameroon.svg";
import { ReactComponent as CnFlagIcon } from "./flags/svgs/cn China.svg";
import { ReactComponent as CoFlagIcon } from "./flags/svgs/co Colombia.svg";
import { ReactComponent as CpFlagIcon } from "./flags/svgs/cp Clipperton Island.svg";
import { ReactComponent as CrFlagIcon } from "./flags/svgs/cr Costa Rica.svg";
import { ReactComponent as CuFlagIcon } from "./flags/svgs/cu Cuba.svg";
import { ReactComponent as CvFlagIcon } from "./flags/svgs/cv Cabo Verde.svg";
import { ReactComponent as CwFlagIcon } from "./flags/svgs/cw Curacao.svg";
import { ReactComponent as CxFlagIcon } from "./flags/svgs/cx Christmas Island.svg";
import { ReactComponent as CyFlagIcon } from "./flags/svgs/cy Cyprus.svg";
import { ReactComponent as CzFlagIcon } from "./flags/svgs/cz Czech Republic.svg";
import { ReactComponent as DeFlagIcon } from "./flags/svgs/de Germany.svg";
import { ReactComponent as DgFlagIcon } from "./flags/svgs/dg Diego Garcia.svg";
import { ReactComponent as DjFlagIcon } from "./flags/svgs/dj Djibouti.svg";
import { ReactComponent as DkFlagIcon } from "./flags/svgs/dk Denmark.svg";
import { ReactComponent as DmFlagIcon } from "./flags/svgs/dm Dominica.svg";
import { ReactComponent as DoFlagIcon } from "./flags/svgs/do Dominican Republic.svg";
import { ReactComponent as DzFlagIcon } from "./flags/svgs/dz Algeria.svg";
import { ReactComponent as FiFlagIcon } from "./flags/svgs/fi Finland.svg";
import { ReactComponent as FmFlagIcon } from "./flags/svgs/fm Federated States of Micronesia.svg";
import { ReactComponent as FjFlagIcon } from "./flags/svgs/fj Fiji.svg";
import { ReactComponent as FkFlagIcon } from "./flags/svgs/fk Falkland Islands.svg";
import { ReactComponent as FoFlagIcon } from "./flags/svgs/fo Faroe Islands.svg";
import { ReactComponent as FrFlagIcon } from "./flags/svgs/fr France.svg";
import { ReactComponent as EaFlagIcon } from "./flags/svgs/ea Ceuta & Melilla.svg";
import { ReactComponent as EcFlagIcon } from "./flags/svgs/ec Ecuador.svg";
import { ReactComponent as EeFlagIcon } from "./flags/svgs/ee Estonia.svg";
import { ReactComponent as EgFlagIcon } from "./flags/svgs/eg Egypt.svg";
import { ReactComponent as EhFlagIcon } from "./flags/svgs/eh Western Sahara.svg";
import { ReactComponent as ErFlagIcon } from "./flags/svgs/er Eritrea.svg";
import { ReactComponent as EsFlagIcon } from "./flags/svgs/es Spain.svg";
import { ReactComponent as Es_ctFlagIcon } from "./flags/svgs/es-ct Catalonia.svg";
import { ReactComponent as Es_gaFlagIcon } from "./flags/svgs/es-ga Galicia.svg";
import { ReactComponent as EtFlagIcon } from "./flags/svgs/et Ethiopia.svg";
import { ReactComponent as EuFlagIcon } from "./flags/svgs/eu Europe.svg";
import { ReactComponent as GaFlagIcon } from "./flags/svgs/ga Gabon.svg";
import { ReactComponent as GbFlagIcon } from "./flags/svgs/gb United Kingdom uk.svg";
import { ReactComponent as Gb_engFlagIcon } from "./flags/svgs/gb-eng England.svg";
import { ReactComponent as Gb_nirFlagIcon } from "./flags/svgs/gb-nir Northern Ireland.svg";
import { ReactComponent as Gb_sctFlagIcon } from "./flags/svgs/gb-sct Scotland.svg";
import { ReactComponent as Gb_wlsFlagIcon } from "./flags/svgs/gb-wls Wales.svg";
import { ReactComponent as GdFlagIcon } from "./flags/svgs/gd Grenada.svg";
import { ReactComponent as GeFlagIcon } from "./flags/svgs/ge Georgia.svg";
import { ReactComponent as GfFlagIcon } from "./flags/svgs/gf French Guiana.svg";
import { ReactComponent as GgFlagIcon } from "./flags/svgs/gg Guernsey.svg";
import { ReactComponent as GhFlagIcon } from "./flags/svgs/gh Ghana.svg";
import { ReactComponent as GiFlagIcon } from "./flags/svgs/gi Gibraltar.svg";
import { ReactComponent as GlFlagIcon } from "./flags/svgs/gl Greenland.svg";
import { ReactComponent as GmFlagIcon } from "./flags/svgs/gm Gambia.svg";
import { ReactComponent as GnFlagIcon } from "./flags/svgs/gn Guinea.svg";
import { ReactComponent as GpFlagIcon } from "./flags/svgs/gp Guadeloupe.svg";
import { ReactComponent as GqFlagIcon } from "./flags/svgs/gq Equatorial Guinea.svg";
import { ReactComponent as GrFlagIcon } from "./flags/svgs/gr Greece.svg";
import { ReactComponent as GsFlagIcon } from "./flags/svgs/gs South Georgia and the South Sandwich Islands.svg";
import { ReactComponent as GtFlagIcon } from "./flags/svgs/gt Guatemala.svg";
import { ReactComponent as GuFlagIcon } from "./flags/svgs/gu Guam.svg";
import { ReactComponent as GwFlagIcon } from "./flags/svgs/gw Guinea-Bissau.svg";
import { ReactComponent as GyFlagIcon } from "./flags/svgs/gy Guyana.svg";
import { ReactComponent as HkFlagIcon } from "./flags/svgs/hk Hong Kong.svg";
import { ReactComponent as HmFlagIcon } from "./flags/svgs/hm Heard Island and McDonald Islands.svg";
import { ReactComponent as HnFlagIcon } from "./flags/svgs/hn Honduras.svg";
import { ReactComponent as HrFlagIcon } from "./flags/svgs/hr Croatia.svg";
import { ReactComponent as HtFlagIcon } from "./flags/svgs/ht Haiti.svg";
import { ReactComponent as HuFlagIcon } from "./flags/svgs/hu Hungary.svg";
import { ReactComponent as IcFlagIcon } from "./flags/svgs/ic Canary Islands.svg";
import { ReactComponent as IdFlagIcon } from "./flags/svgs/id Indonesia.svg";
import { ReactComponent as IeFlagIcon } from "./flags/svgs/ie Ireland.svg";
import { ReactComponent as IlFlagIcon } from "./flags/svgs/il Israel.svg";
import { ReactComponent as ImFlagIcon } from "./flags/svgs/im Isle of Man.svg";
import { ReactComponent as InFlagIcon } from "./flags/svgs/in India.svg";
import { ReactComponent as IoFlagIcon } from "./flags/svgs/io British Indian Ocean Territory.svg";
import { ReactComponent as IqFlagIcon } from "./flags/svgs/iq Iraq.svg";
import { ReactComponent as IrFlagIcon } from "./flags/svgs/ir Iran.svg";
import { ReactComponent as IsFlagIcon } from "./flags/svgs/is Iceland.svg";
import { ReactComponent as ItFlagIcon } from "./flags/svgs/it Italy.svg";
import { ReactComponent as JeFlagIcon } from "./flags/svgs/je Jersey.svg";
import { ReactComponent as JmFlagIcon } from "./flags/svgs/jm Jamaica.svg";
import { ReactComponent as JoFlagIcon } from "./flags/svgs/jo Jordan.svg";
import { ReactComponent as JpFlagIcon } from "./flags/svgs/jp Japan.svg";
import { ReactComponent as KeFlagIcon } from "./flags/svgs/ke Kenya.svg";
import { ReactComponent as KgFlagIcon } from "./flags/svgs/kg Kyrgyzstan.svg";
import { ReactComponent as KhFlagIcon } from "./flags/svgs/kh Cambodia.svg";
import { ReactComponent as KiFlagIcon } from "./flags/svgs/ki Kiribati.svg";
import { ReactComponent as KmFlagIcon } from "./flags/svgs/km Comoros.svg";
import { ReactComponent as KnFlagIcon } from "./flags/svgs/kn Saint Kitts and Nevis.svg";
import { ReactComponent as KrFlagIcon } from "./flags/svgs/kr South Korea.svg";
import { ReactComponent as KwFlagIcon } from "./flags/svgs/kw Kuwait.svg";
import { ReactComponent as KyFlagIcon } from "./flags/svgs/ky Cayman Islands.svg";
import { ReactComponent as KzFlagIcon } from "./flags/svgs/kz Kazakhstan.svg";
import { ReactComponent as LaFlagIcon } from "./flags/svgs/la Laos.svg";
import { ReactComponent as LbFlagIcon } from "./flags/svgs/lb Lebanon.svg";
import { ReactComponent as LcFlagIcon } from "./flags/svgs/lc Saint Lucia.svg";
import { ReactComponent as LiFlagIcon } from "./flags/svgs/li Liechtenstein.svg";
import { ReactComponent as LkFlagIcon } from "./flags/svgs/lk Sri Lanka.svg";
import { ReactComponent as LrFlagIcon } from "./flags/svgs/lr Liberia.svg";
import { ReactComponent as LsFlagIcon } from "./flags/svgs/ls Lesotho.svg";
import { ReactComponent as LtFlagIcon } from "./flags/svgs/lt Lithuania.svg";
import { ReactComponent as LuFlagIcon } from "./flags/svgs/lu Luxembourg.svg";
import { ReactComponent as LvFlagIcon } from "./flags/svgs/lv Latvia.svg";
import { ReactComponent as LyFlagIcon } from "./flags/svgs/ly Libya.svg";
import { ReactComponent as MaFlagIcon } from "./flags/svgs/ma Morocco.svg";
import { ReactComponent as McFlagIcon } from "./flags/svgs/mc Monaco.svg";
import { ReactComponent as MdFlagIcon } from "./flags/svgs/md Moldova.svg";
import { ReactComponent as MeFlagIcon } from "./flags/svgs/me Montenegro.svg";
import { ReactComponent as MfFlagIcon } from "./flags/svgs/mf Saint Martin.svg";
import { ReactComponent as MgFlagIcon } from "./flags/svgs/mg Madagascar.svg";
import { ReactComponent as MhFlagIcon } from "./flags/svgs/mh Marshall Islands.svg";
import { ReactComponent as MkFlagIcon } from "./flags/svgs/mk North Macedonia.svg";
import { ReactComponent as MlFlagIcon } from "./flags/svgs/ml Mali.svg";
import { ReactComponent as MmFlagIcon } from "./flags/svgs/mm Myanmar.svg";
import { ReactComponent as MnFlagIcon } from "./flags/svgs/mn Mongolia.svg";
import { ReactComponent as MpFlagIcon } from "./flags/svgs/mp Northern Mariana Islands.svg";
import { ReactComponent as MqFlagIcon } from "./flags/svgs/mq Martinique.svg";
import { ReactComponent as MrFlagIcon } from "./flags/svgs/mr Mauritania.svg";
import { ReactComponent as MsFlagIcon } from "./flags/svgs/ms Montserrat.svg";
import { ReactComponent as MtFlagIcon } from "./flags/svgs/mt Malta.svg";
import { ReactComponent as MuFlagIcon } from "./flags/svgs/mu Mauritius.svg";
import { ReactComponent as MvFlagIcon } from "./flags/svgs/mv Maldives.svg";
import { ReactComponent as MwFlagIcon } from "./flags/svgs/mw Malawi.svg";
import { ReactComponent as MxFlagIcon } from "./flags/svgs/mx Mexico.svg";
import { ReactComponent as MyFlagIcon } from "./flags/svgs/my Malaysia.svg";
import { ReactComponent as MzFlagIcon } from "./flags/svgs/mz Mozambique.svg";
import { ReactComponent as NaFlagIcon } from "./flags/svgs/na Namibia.svg";
import { ReactComponent as NcFlagIcon } from "./flags/svgs/nc New Caledonia.svg";
import { ReactComponent as NeFlagIcon } from "./flags/svgs/ne Niger.svg";
import { ReactComponent as NfFlagIcon } from "./flags/svgs/nf Norfolk Island.svg";
import { ReactComponent as NgFlagIcon } from "./flags/svgs/ng Nigeria.svg";
import { ReactComponent as NiFlagIcon } from "./flags/svgs/ni Nicaragua.svg";
import { ReactComponent as NlFlagIcon } from "./flags/svgs/nl Netherlands.svg";
import { ReactComponent as NoFlagIcon } from "./flags/svgs/no Norway.svg";
import { ReactComponent as NpFlagIcon } from "./flags/svgs/np Nepal.svg";
import { ReactComponent as NrFlagIcon } from "./flags/svgs/nr Nauru.svg";
import { ReactComponent as NuFlagIcon } from "./flags/svgs/nu Niue.svg";
import { ReactComponent as NzFlagIcon } from "./flags/svgs/nz New Zealand.svg";
import { ReactComponent as OmFlagIcon } from "./flags/svgs/om Oman.svg";
import { ReactComponent as PaFlagIcon } from "./flags/svgs/pa Panama.svg";
import { ReactComponent as PeFlagIcon } from "./flags/svgs/pe Peru.svg";
import { ReactComponent as PfFlagIcon } from "./flags/svgs/pf French Polynesia.svg";
import { ReactComponent as PgFlagIcon } from "./flags/svgs/pg Papua New Guinea.svg";
import { ReactComponent as PhFlagIcon } from "./flags/svgs/ph Philippines.svg";
import { ReactComponent as PkFlagIcon } from "./flags/svgs/pk Pakistan.svg";
import { ReactComponent as PlFlagIcon } from "./flags/svgs/pl Poland.svg";
import { ReactComponent as PmFlagIcon } from "./flags/svgs/pm Saint Pierre and Miquelon.svg";
import { ReactComponent as PnFlagIcon } from "./flags/svgs/pn Pitcairn.svg";
import { ReactComponent as PrFlagIcon } from "./flags/svgs/pr Puerto Rico.svg";
import { ReactComponent as PsFlagIcon } from "./flags/svgs/ps State of Palestine.svg";
import { ReactComponent as PtFlagIcon } from "./flags/svgs/pt Portugal.svg";
import { ReactComponent as PwFlagIcon } from "./flags/svgs/pw Palau.svg";
import { ReactComponent as PyFlagIcon } from "./flags/svgs/py Paraguay.svg";
import { ReactComponent as QaFlagIcon } from "./flags/svgs/qa Qatar.svg";
import { ReactComponent as ReFlagIcon } from "./flags/svgs/re Reunion.svg";
import { ReactComponent as RoFlagIcon } from "./flags/svgs/ro Romania.svg";
import { ReactComponent as RsFlagIcon } from "./flags/svgs/rs Serbia.svg";
import { ReactComponent as RuFlagIcon } from "./flags/svgs/ru Russia.svg";
import { ReactComponent as RwFlagIcon } from "./flags/svgs/rw Rwanda.svg";
import { ReactComponent as SaFlagIcon } from "./flags/svgs/sa Saudi Arabia.svg";
import { ReactComponent as SbFlagIcon } from "./flags/svgs/sb Solomon Islands.svg";
import { ReactComponent as ScFlagIcon } from "./flags/svgs/sc Seychelles.svg";
import { ReactComponent as SdFlagIcon } from "./flags/svgs/sd Sudan.svg";
import { ReactComponent as SeFlagIcon } from "./flags/svgs/se Sweden.svg";
import { ReactComponent as SgFlagIcon } from "./flags/svgs/sg Singapore.svg";
import { ReactComponent as ShFlagIcon } from "./flags/svgs/sh Saint Helena, Ascension and Tristan da Cunha.svg";
import { ReactComponent as SiFlagIcon } from "./flags/svgs/si Slovenia.svg";
import { ReactComponent as SjFlagIcon } from "./flags/svgs/sj Svalbard and Jan Mayen.svg";
import { ReactComponent as SkFlagIcon } from "./flags/svgs/sk Slovakia.svg";
import { ReactComponent as SlFlagIcon } from "./flags/svgs/sl Sierra Leone.svg";
import { ReactComponent as SmFlagIcon } from "./flags/svgs/sm San Marino.svg";
import { ReactComponent as SnFlagIcon } from "./flags/svgs/sn Senegal.svg";
import { ReactComponent as SoFlagIcon } from "./flags/svgs/so Somalia.svg";
import { ReactComponent as SrFlagIcon } from "./flags/svgs/sr Suriname.svg";
import { ReactComponent as SsFlagIcon } from "./flags/svgs/ss South Sudan.svg";
import { ReactComponent as StFlagIcon } from "./flags/svgs/st Sao Tome and Principe.svg";
import { ReactComponent as SvFlagIcon } from "./flags/svgs/sv El Salvador.svg";
import { ReactComponent as SxFlagIcon } from "./flags/svgs/sx Sint Maarten.svg";
import { ReactComponent as SyFlagIcon } from "./flags/svgs/sy Syria.svg";
import { ReactComponent as SzFlagIcon } from "./flags/svgs/sz Eswatini.svg";
import { ReactComponent as TaFlagIcon } from "./flags/svgs/ta Tristan da Cunha.svg";
import { ReactComponent as TcFlagIcon } from "./flags/svgs/tc Turks and Caicos Islands.svg";
import { ReactComponent as TdFlagIcon } from "./flags/svgs/td Chad.svg";
import { ReactComponent as TfFlagIcon } from "./flags/svgs/tf French Southern Territories.svg";
import { ReactComponent as TgFlagIcon } from "./flags/svgs/tg Togo.svg";
import { ReactComponent as ThFlagIcon } from "./flags/svgs/th Thailand.svg";
import { ReactComponent as TjFlagIcon } from "./flags/svgs/tj Tajikistan.svg";
import { ReactComponent as TkFlagIcon } from "./flags/svgs/tk Tokelau.svg";
import { ReactComponent as TlFlagIcon } from "./flags/svgs/tl Timor-Leste.svg";
import { ReactComponent as TmFlagIcon } from "./flags/svgs/tm Turkmenistan.svg";
import { ReactComponent as TnFlagIcon } from "./flags/svgs/tn Tunisia.svg";
import { ReactComponent as ToFlagIcon } from "./flags/svgs/to Tonga.svg";
import { ReactComponent as TrFlagIcon } from "./flags/svgs/tr Turkey.svg";
import { ReactComponent as TtFlagIcon } from "./flags/svgs/tt Trinidad and Tobago.svg";
import { ReactComponent as TvFlagIcon } from "./flags/svgs/tv Tuvalu.svg";
import { ReactComponent as TwFlagIcon } from "./flags/svgs/tw Taiwan.svg";
import { ReactComponent as TzFlagIcon } from "./flags/svgs/tz Tanzania.svg";
import { ReactComponent as UaFlagIcon } from "./flags/svgs/ua Ukraine.svg";
import { ReactComponent as UgFlagIcon } from "./flags/svgs/ug Uganda.svg";
import { ReactComponent as UmFlagIcon } from "./flags/svgs/um United States Minor Outlying Islands.svg";
import { ReactComponent as UnFlagIcon } from "./flags/svgs/un United Nations.svg";
import { ReactComponent as UsFlagIcon } from "./flags/svgs/us United States of America usa.svg";
import { ReactComponent as UyFlagIcon } from "./flags/svgs/uy Uruguay.svg";
import { ReactComponent as UzFlagIcon } from "./flags/svgs/uz Uzbekistan.svg";
import { ReactComponent as VaFlagIcon } from "./flags/svgs/va Holy See.svg";
import { ReactComponent as VcFlagIcon } from "./flags/svgs/vc Saint Vincent and the Grenadines.svg";
import { ReactComponent as VeFlagIcon } from "./flags/svgs/ve Venezuela.svg";
import { ReactComponent as VgFlagIcon } from "./flags/svgs/vg Virgin Islands (British).svg";
import { ReactComponent as ViFlagIcon } from "./flags/svgs/vi Virgin Islands (U.S.).svg";
import { ReactComponent as VnFlagIcon } from "./flags/svgs/vn Vietnam.svg";
import { ReactComponent as VuFlagIcon } from "./flags/svgs/vu Vanuatu.svg";
import { ReactComponent as WfFlagIcon } from "./flags/svgs/wf Wallis and Futuna.svg";
import { ReactComponent as WsFlagIcon } from "./flags/svgs/ws Samoa.svg";
import { ReactComponent as XkFlagIcon } from "./flags/svgs/xk Kosovo.svg";
import { ReactComponent as XxFlagIcon } from "./flags/svgs/xx Unknown.svg";
import { ReactComponent as YeFlagIcon } from "./flags/svgs/ye Yemen.svg";
import { ReactComponent as YtFlagIcon } from "./flags/svgs/yt Mayotte.svg";
import { ReactComponent as ZaFlagIcon } from "./flags/svgs/za South Africa.svg";
import { ReactComponent as ZmFlagIcon } from "./flags/svgs/zm Zambia.svg";
import { ReactComponent as ZwFlagIcon } from "./flags/svgs/zw Zimbabwe.svg";

const iconComponents = {
  flags: {
    AcFlagIcon,
    AdFlagIcon,
    AeFlagIcon,
    AfFlagIcon,
    AgFlagIcon,
    AiFlagIcon,
    AlFlagIcon,
    AmFlagIcon,
    AoFlagIcon,
    AqFlagIcon,
    ArFlagIcon,
    AsFlagIcon,
    AtFlagIcon,
    AuFlagIcon,
    AwFlagIcon,
    AxFlagIcon,
    AzFlagIcon,
    BaFlagIcon,
    BbFlagIcon,
    BdFlagIcon,
    BeFlagIcon,
    BfFlagIcon,
    BgFlagIcon,
    BhFlagIcon,
    BiFlagIcon,
    BjFlagIcon,
    BlFlagIcon,
    BmFlagIcon,
    BnFlagIcon,
    BoFlagIcon,
    BqFlagIcon,
    BrFlagIcon,
    BsFlagIcon,
    BtFlagIcon,
    BvFlagIcon,
    BwFlagIcon,
    ByFlagIcon,
    BzFlagIcon,
    CaFlagIcon,
    CcFlagIcon,
    CdFlagIcon,
    CeftaFlagIcon,
    CfFlagIcon,
    CgFlagIcon,
    ChFlagIcon,
    CiFlagIcon,
    CkFlagIcon,
    ClFlagIcon,
    CmFlagIcon,
    CnFlagIcon,
    CoFlagIcon,
    CpFlagIcon,
    CrFlagIcon,
    CuFlagIcon,
    CvFlagIcon,
    CwFlagIcon,
    CxFlagIcon,
    CyFlagIcon,
    CzFlagIcon,
    DeFlagIcon,
    DgFlagIcon,
    DjFlagIcon,
    DkFlagIcon,
    DmFlagIcon,
    DoFlagIcon,
    DzFlagIcon,
    EaFlagIcon,
    EcFlagIcon,
    EeFlagIcon,
    EgFlagIcon,
    EhFlagIcon,
    ErFlagIcon,
    EsFlagIcon,
    Es_ctFlagIcon,
    Es_gaFlagIcon,
    EtFlagIcon,
    EuFlagIcon,
    FiFlagIcon,
    FjFlagIcon,
    FkFlagIcon,
    FmFlagIcon,
    FoFlagIcon,
    FrFlagIcon,
    GaFlagIcon,
    GbFlagIcon,
    Gb_engFlagIcon,
    Gb_nirFlagIcon,
    Gb_sctFlagIcon,
    Gb_wlsFlagIcon,
    GdFlagIcon,
    GeFlagIcon,
    GfFlagIcon,
    GgFlagIcon,
    GhFlagIcon,
    GiFlagIcon,
    GlFlagIcon,
    GmFlagIcon,
    GnFlagIcon,
    GpFlagIcon,
    GqFlagIcon,
    GrFlagIcon,
    GsFlagIcon,
    GtFlagIcon,
    GuFlagIcon,
    GwFlagIcon,
    GyFlagIcon,
    HkFlagIcon,
    HmFlagIcon,
    HnFlagIcon,
    HrFlagIcon,
    HtFlagIcon,
    HuFlagIcon,
    IcFlagIcon,
    IdFlagIcon,
    IeFlagIcon,
    IlFlagIcon,
    ImFlagIcon,
    InFlagIcon,
    IoFlagIcon,
    IqFlagIcon,
    IrFlagIcon,
    IsFlagIcon,
    ItFlagIcon,
    JeFlagIcon,
    JmFlagIcon,
    JoFlagIcon,
    JpFlagIcon,
    KeFlagIcon,
    KgFlagIcon,
    KhFlagIcon,
    KiFlagIcon,
    KmFlagIcon,
    KnFlagIcon,
    KrFlagIcon,
    KwFlagIcon,
    KyFlagIcon,
    KzFlagIcon,
    LaFlagIcon,
    LbFlagIcon,
    LcFlagIcon,
    LiFlagIcon,
    LkFlagIcon,
    LrFlagIcon,
    LsFlagIcon,
    LtFlagIcon,
    LuFlagIcon,
    LvFlagIcon,
    LyFlagIcon,
    MaFlagIcon,
    McFlagIcon,
    MdFlagIcon,
    MeFlagIcon,
    MfFlagIcon,
    MgFlagIcon,
    MhFlagIcon,
    MkFlagIcon,
    MlFlagIcon,
    MmFlagIcon,
    MnFlagIcon,
    MpFlagIcon,
    MqFlagIcon,
    MrFlagIcon,
    MsFlagIcon,
    MtFlagIcon,
    MuFlagIcon,
    MvFlagIcon,
    MwFlagIcon,
    MxFlagIcon,
    MyFlagIcon,
    MzFlagIcon,
    NaFlagIcon,
    NcFlagIcon,
    NeFlagIcon,
    NfFlagIcon,
    NgFlagIcon,
    NiFlagIcon,
    NlFlagIcon,
    NoFlagIcon,
    NpFlagIcon,
    NrFlagIcon,
    NuFlagIcon,
    NzFlagIcon,
    OmFlagIcon,
    PaFlagIcon,
    PeFlagIcon,
    PfFlagIcon,
    PgFlagIcon,
    PhFlagIcon,
    PkFlagIcon,
    PlFlagIcon,
    PmFlagIcon,
    PnFlagIcon,
    PrFlagIcon,
    PsFlagIcon,
    PtFlagIcon,
    PwFlagIcon,
    PyFlagIcon,
    QaFlagIcon,
    ReFlagIcon,
    RoFlagIcon,
    RsFlagIcon,
    RuFlagIcon,
    RwFlagIcon,
    SaFlagIcon,
    SbFlagIcon,
    ScFlagIcon,
    SeFlagIcon,
    SdFlagIcon,
    SgFlagIcon,
    ShFlagIcon,
    SiFlagIcon,
    SjFlagIcon,
    SkFlagIcon,
    SlFlagIcon,
    SmFlagIcon,
    SnFlagIcon,
    SoFlagIcon,
    SrFlagIcon,
    SsFlagIcon,
    StFlagIcon,
    SvFlagIcon,
    SxFlagIcon,
    SyFlagIcon,
    SzFlagIcon,
    TaFlagIcon,
    TcFlagIcon,
    TdFlagIcon,
    TfFlagIcon,
    TgFlagIcon,
    ThFlagIcon,
    TjFlagIcon,
    TkFlagIcon,
    TlFlagIcon,
    TmFlagIcon,
    TnFlagIcon,
    ToFlagIcon,
    TrFlagIcon,
    TtFlagIcon,
    TvFlagIcon,
    TwFlagIcon,
    TzFlagIcon,
    UaFlagIcon,
    UgFlagIcon,
    UmFlagIcon,
    UnFlagIcon,
    UsFlagIcon,
    UyFlagIcon,
    UzFlagIcon,
    VaFlagIcon,
    VcFlagIcon,
    VeFlagIcon,
    VgFlagIcon,
    ViFlagIcon,
    VnFlagIcon,
    VuFlagIcon,
    WfFlagIcon,
    WsFlagIcon,
    XkFlagIcon,
    XxFlagIcon,
    YeFlagIcon,
    YtFlagIcon,
    ZaFlagIcon,
    ZmFlagIcon,
    ZwFlagIcon,
  },
};
export default iconComponents;
